<shared-ui-page-toolbars-header [text]="'uploader-small' | translate"></shared-ui-page-toolbars-header>
<div class="m-3">
  <div class="ibox-content text-center">
    <img src="{{ appConfig.statics.blueLogo }}" />
    <div class="m-t-lg">
      <h1>
        {{ 'tenant-name' | translate }} <br />
        <span class="text-navy">Uploader</span>
      </h1>
    </div>
    <div class="hr-line-dashed col-lg-4 mx-auto"></div>
    <div class="p-m col-lg-4 mx-auto">
      <p>
        <strong>
          {{ 'tenant-name' | translate }}
          <span class="text-navy">Uploader </span>
        </strong>
        {{ 'uploader-description' | translate }}
      </p>
      <shared-ui-buttons-button [type]="buttonType" [text]="'uploader' | translate" (action)="goToDownloadPage()"></shared-ui-buttons-button>
    </div>
  </div>
</div>
